import { render } from "./K.vue?vue&type=template&id=12ac9eed"
import script from "./K.vue?vue&type=script&lang=js"
export * from "./K.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__